import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

// Type definitions for select2
declare global {
  interface JQuery {
    select2(options?: Record<string, unknown>): JQuery
    select2(command: string, ...args: unknown[]): unknown
  }
}

// Connects to data-controller="consolidation-tree"
export default class extends Controller {
  private formTarget!: HTMLFormElement
  private selectTarget!: HTMLInputElement
  private submitTarget!: HTMLInputElement
  private chevronTargets!: HTMLElement[]
  private consolidationCompanyIdValue!: string

  static targets = ['form', 'select', 'submit', 'chevron']

  static values = {
    consolidationCompanyId: String,
  }

  setupSelect2(element: HTMLInputElement): void {
    $(element).select2({
      width: '100%',
      ajax: {
        url: window.Silverfin.Routes.autocomplete_companies_path({
          firm_id: window.Silverfin.currentFirmId,
        }),
        dataType: 'json',
        delay: 250,
        data: (params: { term: string }) => ({
          q: params.term,
          consolidation_company_id: this.consolidationCompanyIdValue,
        }),
        processResults: (data: object) => {
          return {
            results: data,
          }
        },
      },
      theme: 'silverfin',
      minimumInputLength: 2,
      templateResult: (company: { name: string }) => company.name,
      templateSelection: (company: { name: string; text: string }) => {
        if (company.text !== '') {
          // placeholder situation
          return company.text
        } else {
          return company.name
        }
      },
    })
  }

  selectTargetConnected(element: HTMLInputElement): void {
    this.setupSelect2(element)

    $(element).on('change', () => {
      if ($(this.selectTarget).find(':selected').val() !== '') {
        this.enableSubmit()
        setTimeout(() => this.submitTarget.focus(), 0)
      } else {
        this.disableSubmit()
      }
    })
  }

  disableSubmit(): void {
    this.submitTarget.classList.add('sf-disabled')
    this.submitTarget.classList.remove('sf-btn-success')
  }

  enableSubmit(): void {
    this.submitTarget.classList.remove('sf-disabled')
    this.submitTarget.classList.add('sf-btn-success')
  }

  toggleChevrons(event: {
    target: HTMLElement
    params: { companyId: string }
  }): void {
    event.target.classList.toggle('fa-chevron-down')
    event.target.classList.toggle('fa-chevron-right')

    $(`[data-child-of="${event.params.companyId}"]`).toggle()
  }
}
